// extracted by mini-css-extract-plugin
export default {"container":"ProductForm_container__WQgvK","productForm":"ProductForm_productForm__tuv5F","formContainer":"ProductForm_formContainer__cK0G0"};